export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY'
export const RECEIVE_COMPETENCY = 'RECEIVE_COMPETENCY'
export const RECEIVE_ACTIVITY_ANSWER = 'RECEIVE_ACTIVITY_ANSWER'


function receiveActivity(activityId,activity) {
  return {
    type: RECEIVE_ACTIVITY,
    activityId,
    activity,
    receivedAt: Date.now()
  }
}

function receiveCp(activityId,competencyId,competency) {
  return {
    type: RECEIVE_COMPETENCY,
    activityId,
    competencyId,
    competency,
    receivedAt: Date.now()
  }
}

function receiveAnswer(activityId,competencyId,dimensionId,answer) {
  return  {
    type: RECEIVE_ACTIVITY_ANSWER,
    activityId,
    competencyId,
    dimensionId,
    answer
  }
}

export function fetchActivities(assessmentId,firestore) {
  return dispatch => {
    const assessmentRef = firestore.collection('assessmentsByRater').doc(assessmentId)

    return assessmentRef.get()
      .then(assessment => { 
          const assessmentData = assessment.data()
          return assessmentData })
      .then(data => data && data.activities 
        ? data.activities.map(activity => 
          activity.get().then(act => {
            const actData = act.data() 
            

            actData && actData.competencies 
              ? actData.competencies.map(competency =>
                competency.get().then(cp => {
                    const cpData = cp.data()
                    

                    dispatch(receiveCp(act.id,cp.id, cpData))


                    return cpData              
                  }
                )
              )
              : []

            dispatch(receiveActivity(act.id, actData ))
            return actData
            }  ) )
        : [])
  }
}



// WEBPACK FOOTER //
// ./src/modules/activities/actions.js